<template>
  <div>
    <h1>简历管理</h1>
    <el-upload
      class="upload-demo"
      :action="apibase+'/upload_resume'"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :on-change="handleChange" 
    >
      <el-button size="small" type="primary">上传PDF简历</el-button>
      <template #tip>
        <div class="el-upload__tip">上传后大约需要5秒进行AI分析</div>
        
      </template>
    </el-upload>
    <el-table :data="resumeList" style="width: 100%">
      <el-table-column prop="name" label="姓名" width="180"></el-table-column>
      <el-table-column prop="phone" label="电话" width="180"></el-table-column>
      <el-table-column prop="education" label="教育"></el-table-column>
      <el-table-column prop="experience" label="经验"></el-table-column>
      <!-- <el-table-column prop="skills" label="技能"></el-table-column> -->
      
      <el-table-column label="Actions" width="350">
        <template #default="scope">
          <el-button size="small" @click="handleViewDetail(scope.row)">查看详细</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加对话框 -->
    <el-dialog title="简历详情" v-model="dialogVisible" width="50%">
      <div>
        <p><strong>ID:</strong> {{ selectedResume.id }}</p>
        <p><strong>姓名:</strong> {{ selectedResume.name }}</p>
        <p><strong>邮箱:</strong> {{ selectedResume.email }}</p>
        <p><strong>联系电话:</strong> {{ selectedResume.phone }}</p>
        <p><strong>地址:</strong> {{ selectedResume.address }}</p>
        <p><strong>教育背景:</strong> {{ selectedResume.education }}</p>
        <p><strong>工作经验:</strong> {{ selectedResume.experience }}</p>
        <p><strong>专业技能:</strong> {{ selectedResume.skills }}</p>
        <p><strong>创建时间:</strong> {{ selectedResume.created_at }}</p>
        <p><strong>更新时间:</strong> {{ selectedResume.updated_at }}</p>
        <p><strong>全名:</strong> {{ selectedResume.full_name }}</p>
        <p><strong>联系电话:</strong> {{ selectedResume.phone_number }}</p>
        <p><strong>当前所在地:</strong> {{ selectedResume.location }}</p>
        <p><strong>详细工作经历:</strong> {{ selectedResume.work_experience }}</p>
        <p><strong>工作年限:</strong> {{ selectedResume.experience_years }}</p>
        <p><strong>当前职位:</strong> {{ selectedResume.current_position }}</p>
        <p><strong>当前公司:</strong> {{ selectedResume.current_company }}</p>
        <p><strong>最高学历:</strong> {{ selectedResume.education_level }}</p>
        <p><strong>教育经历:</strong> {{ selectedResume.education_history }}</p>
        <p><strong>简历源文件:</strong> <a :href="'/'+selectedResume.resume_file" target="_blank">打开</a></p>
        <p><strong>期望薪资:</strong> {{ selectedResume.expected_salary }}</p>
        <p><strong>期望职位、行业:</strong> {{ selectedResume.job_preferences }}</p>
        <p><strong>掌握的语言及熟练度:</strong> {{ selectedResume.languages }}</p>
        <p><strong>证书:</strong> {{ selectedResume.certifications }}</p>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElUpload, ElTable, ElTableColumn, ElButton, ElDialog } from 'element-plus';
import { fetchData, postData } from '@/api.js'; // 导入 postData 函数

export default {
  name: 'ResumeManagement',
  components: {
    ElUpload,
    ElTable,
    ElTableColumn,
    ElButton,
    ElDialog,
  },
  data() {
    return {
      resumeList: [], // 用于存储从后台获取的简历列表
      dialogVisible: false, // 对话框显示控制
      selectedResume: {}, // 选中的简历详细信息
      uploadStatus: '', // 上传状态提示文字
      apibase: process.env.VUE_APP_API_BASE_URL,
    };
  },
  methods: {
    handleChange(file) { // 添加 handleChange 方法
      if (file.status === 'uploading') {
        this.uploadStatus = '上传中，AI分析中';
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.uploadStatus = '文件已移除';
    },
    handlePreview(file) {
      console.log(file);
      this.uploadStatus = '预览文件: ' + file.name;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The limit is 3, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally`);
      this.uploadStatus = '超出文件限制';
    },
    beforeRemove(file) {
      return this.$confirm(`Cancel the transfert of ${ file.name } ?`).then(() => {
        this.uploadStatus = '取消上传: ' + file.name;
      }).catch(() => {
        this.uploadStatus = '上传取消';
      });
    },
    async fetchResumes() { // 从后台读取简历列表
      try {
        const data = await fetchData('resume_list');
        this.resumeList = data;
        this.uploadStatus = '';
      } catch (error) {
        console.error('Error fetching resumes:', error);
      }
    },
    handleUploadSuccess() { // 添加 handleUploadSuccess 方法
      this.uploadStatus = '上传成功，AI分析中';
      this.fetchResumes();
    },
    handleViewDetail(row) {
      this.selectedResume = row; // 存储选中的简历信息
      this.dialogVisible = true; // 显示对话框
    },
    async handleDelete(row) {
      try {
        await postData('del_resume', { id: row.id }); // 使用 postData 函数发送 POST 请求
        this.$message.success('删除成功');
        this.fetchResumes();
      } catch (error) {
        console.error('Error deleting resume:', error);
        this.$message.error('删除失败');
      }
    }
  },
  created() {
    this.fetchResumes(); // 组件加载时获取数据
  },
};
</script>

<style scoped>
.upload-demo {
  margin-bottom: 20px;
}
.upload-status {
  margin-top: 10px;
  color: #606266;
}
</style>